import React, { useContext, useState } from 'react';
import useStyles from "../../style/js-style/components/attributes/ThirdpartyAttributeStyle";
import { Tooltip } from '@mui/material';
import clsx from 'clsx';
import i18next from 'i18next';
import DataTableActions from '../common/datatable/DataTableActions';
import AttributeValueForm from '../../containers/attribute-values/AttributeValueForm';
import { Context } from 'states/Store';
import _ from 'lodash';
import { ERROR } from 'services/common/Constants';
import { refreshThirdpartyInduedTags } from 'services/edge/InduedService';
import { lightenHex } from '../../services/common/Utils';

export const MODE = {
  create: "create",
  edit: "edit"
}

function Attribute({
                               attribute,
                               index,
                               formMethods,
                               mode = MODE.edit,
                               canEditAttribute = () => {return true},
                               isEditAttribute = false,
                               setSelectedAttribute = () => {},
                               customHandleSubmit = null,
                               id,
                               fetchAttributeValuesList = () => {},
                               bondType,
                               sizeOfWrapper
}) {
  const { classes } = useStyles();
  const [state, dispatch] = useContext(Context);
  const [isRefreshing, setIsRefreshing] = useState(false);



  const getCategorizedAttributeActions = (attribute) => {
    let result = []
    if(attribute?.category) {
      switch(attribute.category) {
        case 'indued':
          if(_.find(state.subscriptions, { key: 'INDUED' })?.additionalInfos?.indued?.truthSource === 'indued') {
            result.push({
              label: i18next.t('refresh'),
              isDisabled: isRefreshing,
              icon: 'loop',
              action: () => refreshInduedTag(attribute),
            })
          }
          break;
        default:
          break;
        }
    }
    return result;
  };

  const refreshInduedTag = async () => {
    setIsRefreshing(true);
    try {
      await refreshThirdpartyInduedTags(state.account.id, state.thirdparty.thirdpartyId, dispatch);
      setIsRefreshing(false);
      fetchAttributeValuesList();
    } catch (e) {
      setIsRefreshing(false);
      dispatch({
        type: "ALERT",
        alert: { type: ERROR, msg: "INTERNAL_ERROR" },
      });
    }
  };

  const canEditCategorizedAttribute = (attribute) => {
    let canEdit = true;

    if(attribute?.category) {
      switch(attribute.category) {
        case 'indued':
          canEdit = _.find(state.subscriptions, { key: 'INDUED' })?.additionalInfos?.indued?.truthSource === 'aprovall';
          break;
        default:
          break;
        }
    }
    return canEdit;
  }

  return (
    <>
      <div className={classes.attributeItemWrapper} key={index} style={{maxWidth: sizeOfWrapper}}>
        {/* Label */}
        <div className={clsx(classes.attributeItemLabel, classes.breakWord)} style={{backgroundColor: attribute.color ? lightenHex(attribute.color, 0.8) : ""}}>
          <Tooltip title={attribute.type === 'calculated' ? attribute.label : attribute.id} placement="top">
            <span className={clsx(classes.attributeName, classes.wrapWord)}>
              {attribute.type === 'calculated'
                ? attribute.label
                : attribute.id + (attribute.isRequired ? ' *' : '')}
            </span>
          </Tooltip>
        </div>

        {/* Values */}
        {isEditAttribute ? (
          <AttributeValueForm
            formId={'editAttributeValue'}
            bondType={bondType ?? attribute.bondType}
            attributeValue={attribute}
            setSelectedAttribute={setSelectedAttribute}
            id={id}
            fetchAttributeValuesList={fetchAttributeValuesList}
            customHandleSubmit={customHandleSubmit}
          />
        ) : (
          <div className={classes.attributeItemValues}>
            <Tooltip
              title={
                attribute.type !== 'calculated'
                  ? attribute.shownValues
                  : i18next.t('calculator.attribute.attributeIsNotEditable')
              }
            >
              <div style={{ display: 'flex' }}>
                {attribute.type === 'calculated' && (
                  <div
                    className={classes.attributesItemColor}
                    style={{ backgroundColor: attribute.color || '#E2E2EA' }}
                  />
                )}
                {attribute.shownValues === i18next.t('notSpecified') || !attribute.shownValues ? (
                  <span className={classes.placeholderValue}>
                    {i18next.t('notSpecified')}
                  </span>
                ) : (
                  <span className={classes.wrapWord}>
                    {attribute.shownValues}
                  </span>
                )}
              </div>
            </Tooltip>

            {/* Edit */}
            {attribute.type !== 'calculated' && (
              <div className={classes.attributeItemValuesEdit}>
                <DataTableActions
                  actions={[
                    {
                      label: i18next.t('modify'),
                      icon: 'edit_grey_full',
                      isDisabled: !canEditAttribute(attribute) || !canEditCategorizedAttribute(attribute),
                      action: () =>
                        setSelectedAttribute({ ...attribute, index: index }),
                    },
                    ...getCategorizedAttributeActions(attribute),
                  ]}
                />
              </div>
            )}
          </div>
        )}
      </div>

      {mode === MODE.create &&
        formMethods &&
        formMethods.formState?.errors['attributes']?.[index] && (
          <span className={classes.requieredInfos}>
            {i18next.t('infos.required')}
          </span>
        )}
    </>
  );
}

export default Attribute;
